<template>
  <span class="label">
    {{ text }}
  </span>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
    },
  },
};
</script>

<style scoped>
.label {
  background-color: rgba(235, 102, 25, .15);
  border-radius: 2rem;
  padding: .375rem .75rem .5rem;
  color: #eb6619;
  display: inline-block;
  font-weight: 700;
  font-size: .9375rem;
}
</style>
